var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"subtitle-1 grey-navy--text font-weight-bold text-decoration-none",on:{"click":_vm.navigate}},[_c('v-icon',{staticClass:"pa-3 pl-1",attrs:{"small":!_vm.large,"color":"black"}},[_vm._v(" keyboard_backspace ")]),(!_vm.icon)?_c('span',[_vm._v("Back")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }